import { useState } from 'react';
import useUser from 'src/hook/data/useUser';
import usePopUp from 'src/hook/modal/usePopUp';
import { GetLinkedInUrl, IconLocation, ImageLocation } from 'src/utils/URLUtils';
import styles from './LinkedInPopUp.module.scss';


const LinkedInPopUp = () => {
    const { hide } = usePopUp();
    const [step, setStep] = useState(1);
    const { showCertificatePopUp } = usePopUp();
    const { userInfo } = useUser();

    const handleYes = () => setStep(2);
    const handleNo = () => hide();
    const handleThanks = () => {
        hide();
        if (userInfo?.ShowCertificate)
            showCertificatePopUp();
    };
    const handleFollow = () => {
        window.open(GetLinkedInUrl(), '_blank');
        hide();
        if (userInfo?.ShowCertificate)
            showCertificatePopUp();
    };

    return (
        <div className={styles.linkedInPopUp}>
            {step === 1 ? (
                <>
                    <h1>Do you have a LinkedIn account?</h1>
                    <img src={IconLocation('linkedin')} alt="LinkedIn" className={styles.image} />
                    <div className={styles.buttonRow}>
                        <button className='secondaryButton' onClick={handleNo}>No</button>
                        <button onClick={handleYes}>Yes</button>
                    </div>
                </>
            ) : (
                <>
                    <h1>Follow us on LinkedIn to learn about the latest news.</h1>
                    <img src={ImageLocation('Lexi/follow-us.png')} alt="Follow LinkedIn" className={styles.image} />
                    <div className={styles.buttonRow}>
                        <button className='secondaryButton' onClick={handleThanks}>Thanks</button>
                        <button onClick={handleFollow}>Follow</button>
                    </div>
                </>
            )}
        </div>
    );
};

export default LinkedInPopUp;